<template>
  <div id="materialUseStatisticsDetail">
    <div class="filterConditionContainer">
      <el-card class="box-card">
        <div class="filterCondition" >
          <div class="searchIcon">
            <i class="el-icon-search"></i>
          </div>
          <el-form :inline="true" :model="filterForm" class="filterForm" label-width="120px">
            <el-form-item :label="$t('materialUseStatistics.customTimeScope')" >
              <el-date-picker
                v-model="filterForm.timeScope"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('survey.startTime')"
                :end-placeholder="$t('survey.endTime')"
                align="right">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="8">
              <div class="filterBtns">
                <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                <el-button type="primary" @click="onReset">{{ $t('reset') }}</el-button>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="filterBtns filterBtnsRight">
                <el-button type="primary" @click="exportData()">{{ $t('export') }}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <div class="tableContainer">
      <el-card class="box-card">
        <div class="tableBox">
          <div class="orangeIcon">
            <i class="el-icon-s-order"></i>
          </div>
        </div>
        <div style="margin-top: 20px">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/wo/materialUseStatistics' }">{{ $t('materialUseStatistics.doorList') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ doorName }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-table
            :data="tableData"
            style="width: 100%; margin-top: 20px">
            <el-table-column
              prop="序号"
              type="index"
              width="50">
            </el-table-column>
            <el-table-column
              prop="pushName"
              :label="$t('materialUseStatistics.pushName')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="pushTime"
              :label="$t('materialUseStatistics.pushTime')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="readAmount"
              :label="$t('materialUseStatistics.readAmount')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="reductionReadAmount"
              :label="$t('materialUseStatistics.reductionReadAmount')"
              width="150">
            </el-table-column>
            <el-table-column
              prop="sendPerson"
              :label="$t('materialUseStatistics.sendPerson')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="readRate"
              :label="$t('materialUseStatistics.readRate')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="isUse"
              :label="$t('materialUseStatistics.isUse')"
              width="120"
              :formatter="isUseFormatter"
            >
            </el-table-column>

            <el-table-column
              prop="brandMaterial"
              :label="$t('materialUseStatistics.brandMaterial')"
              width="150">
            </el-table-column>
            <el-table-column
              prop="OOTDMaterial"
              :label="$t('materialUseStatistics.OOTDMaterial')"
              width="140">
            </el-table-column>
            <el-table-column
              prop="paiLiXueTemplate"
              :label="$t('materialUseStatistics.paiLiXueTemplate')"
              width="140">
            </el-table-column>
            <el-table-column
              prop="doorMaterial"
              :label="$t('materialUseStatistics.doorMaterial')"
              width="140">
            </el-table-column>
            <el-table-column
              prop="remark"
              :label="$t('materialUseStatistics.remark')"
              width="140">
            </el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('operation')"
              width="120">
              <template slot-scope="scope">
                <el-button @click="exportData(scope.row)" type="text" size="small">{{ $t('newSurvey.exportData') }}</el-button>
                <router-link :to=" { path:'/wo/pushDetail', query: {id: scope.row.id, pushName: scope.row.pushName} }" target="_blank">
                  <el-button type="text" size="small">{{ $t('more') }}</el-button>
                </router-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagingBox">
            <el-pagination
              background
              @current-change="currentChange"
              :current-page="tableConfig.current"
              layout="total, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Cookies from 'js-cookie'
export default {
  name: 'MaterialUseStatisticsDetail',
  components: {
  },
  data: function () {
    return {
      id: this.$route.query.id || null,
      dialogTableVisible: false,
      initFilterForm: {
        timeScope: '', // 时间段
      },
      doorName: this.$route.query.doorName || null,
      filterForm: {},
      tableData: [],
      tableConfig: {
        current: 1,
        size: 10
      },
      total: 0
    }
  },
  mounted () {
    this.onReset()
  },
  computed: {
  },
  methods: {
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      const params = this.$tool.formatArrayToString(this.filterForm)
      let res = await this.$api.survey_api.listDoor(_.assign(params, this.tableConfig))
      this.tableData = res.list
      this.total = res.total
    },

    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },

    exportData: async function () {
      let { data, fileName } = await this.$tool.exportFile({
        method: 'post',
        url: this.$api.survey_api.base  + '/door/export',
        data: this.$tool.formatArrayToString(this.filterForm)
      })
      console.log(data, fileName)
    },

    currentChange: function (index) {
      this.tableConfig.current = index
      this.onSearch(false)
    },

    isUseFormatter: function(row) {
      switch (row.isInUse) {
        case true:
          return "是"
          break;
        case false:
          return "否"
          break;
        default:
          return "未知"
          break;
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  a
    margin-left: 10px
  .filterConditionContainer
    margin: 40px 20px 20px 20px
  .tableContainer
    margin: 40px 20px
  input[type=file]
    display: none
</style>



// WEBPACK FOOTER //
// src/pages/wo/materialUseStatisticsDetail.vue